import { Component } from '@angular/core';

@Component({
  selector: 'landing-page',
  templateUrl: './landing.component.html',
})
export class LandingComponent {}
